import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
//MUI
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Card from '@material-ui/core/Card';
//ICONS
import PersonIcon from '@material-ui/icons/Person';
import PolicyIcon from '@material-ui/icons/Policy';
//DS
/**
 * Vista de espera y generadora de redireccion con el formato de login data service
 */
function RedirectLogin({
   LoginApiURI,
   originURI,
   callbackURI,
   scope,
   appId,
   appName,
   redirect,
   mostrarRedirectLink,
   logoApp
}) {
   const [urlredirect, seturlredirect] = useState('');
   useEffect(() => {
      if (LoginApiURI) {
         let dsloginUrl = new URL(LoginApiURI);
         dsloginUrl.searchParams.append('redirect_uri', callbackURI);
         dsloginUrl.searchParams.append('client_id', appId);
         dsloginUrl.searchParams.append('scope', scope);
         if (originURI) {
            dsloginUrl.searchParams.append('origin_uri', originURI);
         }
         seturlredirect(dsloginUrl.toString());
      }
   }, []);
   useEffect(() => {
      if (redirect) {
         window.location.replace(urlredirect);
      }
   }, [urlredirect, redirect]);
   return (
      <Card style={{height: 'auto', padding: '10px'}}>
         <Box
            style={{
               display: 'flex',
               alignItems: 'center',
               justifyContent: 'center'
            }}
         >
            <PersonIcon style={{fontSize: 64}} />
            <img
               style={{maxWidth: '80%'}}
               alt="Logo"
               height="100"
               src={logoApp || 'https://www.dscont.pe/dsServices/images/ds-iso9001-logo.png'}
            />
            <PolicyIcon style={{fontSize: 64}} />
         </Box>
         <Box
            style={{
               display: 'flex',
               alignItems: 'center',
               justifyContent: 'center'
            }}
         >
            <Typography variant="h5" color="textSecondary">
               Redireccionando a DS-Login para iniciar sesión en la aplicación {appName}.
            </Typography>
         </Box>
         <LinearProgress />
         <Typography color="textSecondary">{mostrarRedirectLink ? urlredirect : ''}</Typography>
      </Card>
   );
}
RedirectLogin.propTypes = {
   /**
    * URI a la cual redireccionara el componente para realizar el login.
    */
   LoginApiURI: PropTypes.string.isRequired,
   /**
    * URI de origen.
    */
   originURI: PropTypes.string,
   /**
    * URI de retorno para el parametro `redirect_uri` de la url de login.
    */
   callbackURI: PropTypes.string.isRequired,
   /**
    * Scopes solicitados en el parametro `scope` de la url de login.
    */
   scope: PropTypes.string.isRequired,
   /**
    * Identificador de la aplicacion `client_id` de la url de login.
    */
   appId: PropTypes.string,
   /**
    * Nombre de la aplicacion que usa el componente.
    */
   appName: PropTypes.string,
   /**
    * Si es __true__ redireccionara a LoginApiURI, para propositos de depuración.
    */
   redirect: PropTypes.bool,
   /**
    * Si es __true__ mostrara el link a redireccionar con los parametros armado, para propositos de depuración.
    */
   mostrarRedirectLink: PropTypes.bool,
   /**
    * Imagen a de espera a mostrar, se sugiere el logo de la app que usa el componente.
    */
   logoApp: PropTypes.string
};
RedirectLogin.defaultProps = {
   redirect: false,
   mostrarRedirectLink: false
};
export default RedirectLogin;
